"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addHandler = addHandler;
exports.maybeInstrument = maybeInstrument;
exports.resetInstrumentationHandlers = resetInstrumentationHandlers;
exports.triggerHandlers = triggerHandlers;

var _debugBuild = require("../debug-build.js");

var _logger = require("../logger.js");

var _stacktrace = require("../stacktrace.js");

// We keep the handlers globally
const handlers = {};
const instrumented = {};
/** Add a handler function. */

function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */


function resetInstrumentationHandlers() {
  Object.keys(handlers).forEach(key => {
    handlers[key] = undefined;
  });
}
/** Maybe run an instrumentation function, unless it was already called. */


function maybeInstrument(type, instrumentFn) {
  if (!instrumented[type]) {
    instrumented[type] = true;

    try {
      instrumentFn();
    } catch (e) {
      _debugBuild.DEBUG_BUILD && _logger.logger.error(`Error while instrumenting ${type}`, e);
    }
  }
}
/** Trigger handlers for a given instrumentation type. */


function triggerHandlers(type, data) {
  const typeHandlers = type && handlers[type];

  if (!typeHandlers) {
    return;
  }

  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      _debugBuild.DEBUG_BUILD && _logger.logger.error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, _stacktrace.getFunctionName)(handler)}\nError:`, e);
    }
  }
}